var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ol',{staticClass:"breadcrumb"},_vm._l((_vm.routeRecords),function(routeObject,index){return _c('li',{key:index,staticClass:"breadcrumb-item"},[(_vm.isLast(index))?_c('span',{staticClass:"active"},[_vm._v(_vm._s(_vm.getName(routeObject)))]):_c('router-link',{attrs:{"to":_vm.getPath(index)}},[_vm._v(_vm._s(_vm.getName(routeObject)))])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }